import React, { useEffect, useRef } from "react";
import { Spin } from "_c/preloader";
import { Selectors } from "@/store/masterSearch/selectors";
import { connect } from "react-redux";
import { Actions } from "@/store/masterSearch/slice";
import { useInView } from "react-intersection-observer";

const Loader = ({ hasMore, loading, loadMoreMasters, params, query }) => {
  const { ref, inView } = useInView({
    rootMargin: "150px",
  });
  const fetchMoreRef = useRef(() => loadMoreMasters({ params, query }));
  useEffect(() => {
    fetchMoreRef.current = () => loadMoreMasters({ params, query });
  }, [params, query]);
  useEffect(() => {
    if (hasMore && inView) {
      fetchMoreRef.current();
    }
  }, [hasMore, inView]);
  return (
    <div
      ref={ref}
      css={`
        margin-top: 10px;
        height: 50px;
      `}
    >
      {loading && <Spin />}
    </div>
  );
};

export default connect(
  (state) => ({
    loading: Selectors.isLoading(state),
    hasMore: Selectors.hasMore(state),
  }),
  {
    loadMoreMasters: Actions.loadMoreMasters,
  }
)(Loader);
